/** @jsx isolateComponent */

import { Interpolation } from '@emotion/css';
import { isolateComponent, labelStyles } from '@zapier/common-utils';
import { Colors, Link } from '@zapier/design-system';
import { skipLinkHref } from '@zapier/universal-nav/dist/constants';

type Props = {
  /**
   * Anchor to the main content area of the page.
   * **The page must contain a node with the `id` in this prop!**
   */
  href: string;
  /**
   * Link text.
   */
  text: string;
};

const Styles = labelStyles(__filename, {
  root: {
    fontSize: 10,
    textTransform: 'uppercase',
    display: 'block',
    color: Colors.grey700,
    // Hide the link and make it unclickable.
    opacity: 0,
    pointerEvents: 'none',

    // Only show the link on focus.
    '&:focus': {
      opacity: 1,
    },
  },
});

/**
 * Renders an invisible `Skip To Content` link, which becomes visible only if the element receives focus.
 * This improves the browsing experience for users on screenreaders.
 *
 * Tags: link
 */
const SkipLink = (props: Props) => {
  return (
    <Link
      ariaLabel="Skip to content"
      css={Styles.root as Interpolation}
      href={props.href}
    >
      {props.text}
    </Link>
  );
};

SkipLink.defaultProps = {
  href: skipLinkHref,
  text: 'Skip to content',
};

export default SkipLink;
